"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const useStyles = core_1.makeStyles((theme) => ({
    root: {
        fontSize: '14px',
        backgroundColor: theme.palette.info.light,
        color: theme.palette.grey[900],
        border: `1px solid ${theme.palette.info.dark}`,
        borderRadius: 0,
        '& .MuiChip-label': {
            padding: '4px 10px',
        },
        '&:focus': {
            backgroundColor: theme.palette.info.light,
            color: theme.palette.grey[900],
        },
        '& .MuiChip-deleteIcon': {
            color: theme.palette.grey[600],
        },
        '& .MuiChip-deleteIcon:hover': {
            color: theme.palette.grey[900],
        },
    },
}));
const Token = ({ item, onDismiss }) => {
    const styles = useStyles();
    return (react_1.default.createElement(core_1.Chip, { className: styles.root, label: item.label, color: "primary", onDelete: () => {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(item);
        }, deleteIcon: react_1.default.createElement(Close_1.default, null) }));
};
exports.default = Token;
//# sourceMappingURL=index.js.map